/* eslint-disable max-len */
import { useCallback } from 'react';
import CmdItem from '../cmdkItem';
import SVGIcon from '../../../assets/images/svg/SVGIcon';

function RecordItem({
  setInputValue,
  closePopup,
  openSnapModal,
  storeRecentSearch
}: {
  setInputValue: Function;
  closePopup: Function;
  openSnapModal: Function;
  storeRecentSearch: Function;
}) {
  const onRecordSnap = useCallback(() => {
    storeRecentSearch('Record Snap', 8, '');
    openSnapModal();
    setInputValue('');
    closePopup();
  }, [closePopup, openSnapModal, setInputValue, storeRecentSearch]);

  return (
    <>
      <CmdItem
        onSelect={() => {
          onRecordSnap();
        }}>
        <SVGIcon name='record-snap-icon' width='18' height='18' viewBox='0 0 18 18' fill='var(--text-secondary)' />
        Record Snap
      </CmdItem>
    </>
  );
}

export default RecordItem;
